import NewSuperLink from './new/NewSuperLink';
import SuperlinkRespondentImport from './Import/SuperlinkRespondentImport';
import SuperLinkListContainer from './SuperLinkListContainer';
import SuperLinkDetailContainer from './detail/SuperLinkDetailContainer';
import ImportFileDetailContainer from './Import/components/ImportFileDetail/ImportFileDetailContainer';

const superLinkRoutes = [
  { path: '/accounts/:aid/super-links/', component: SuperLinkListContainer, exact: true },
  { path: '/accounts/:aid/super-links/new', component: NewSuperLink },
  { path: '/accounts/:aid/super-links/:superLinkId/import/:importFileId', component: ImportFileDetailContainer },
  { path: '/accounts/:aid/super-links/:superLinkId/import', component: SuperlinkRespondentImport },
  { path: '/accounts/:aid/super-links/:superLinkId', component: SuperLinkDetailContainer },
];

export default superLinkRoutes;
